import { KpkApiOrientationContactSheet } from "@keepeek/api-client";
import { KpkMedia } from "@keepeek/commons";
import { KpkContactSheet } from "@keepeek/refront-components";
import { atom } from "recoil";

export enum ContactSheetsModalOpenStatus {
  ALLOWED = "allowed",
  MAX_REACHED = "max_reached",
}

export const contactSheetsModalOpenStatusState = atom<ContactSheetsModalOpenStatus>({
  key: "ContactSheetsModalOpenStatusState",
  default: ContactSheetsModalOpenStatus.ALLOWED,
});

// Modal opening state
export const contactSheetsModalOpenState = atom<boolean>({
  key: "ContactSheetsModalOpenState",
  default: false,
});

export const contactSheetsModalSelectedElementsState = atom<KpkMedia["id"][]>({
  key: "ContactSheetsModalSelectedElementsState",
  default: [],
});

export const contactSheetsModalSelectedOrientationState = atom<
  KpkApiOrientationContactSheet | undefined
>({
  key: "contactSheetsModalSelectedOrientationState",
  default: KpkApiOrientationContactSheet.PORTRAIT,
});

export const contactSheetsModalSelectedValueState = atom<number | undefined>({
  key: "contactSheetsModalSelectedValueState",
  default: -1,
});

export const contactSheetsModalSelectedContactSheetState = atom<KpkContactSheet>({
  key: "contactSheetsModalSelectedContactSheetState",
  default: { id: 1, title: "" },
});
